import { useContext } from "react";
import { CustomerDataContext } from "@/providers/CustomerDataContext";

export const useUserData = () => {
  return useContext(CustomerDataContext);
};
